
export const APP_TITLE = "IPE Controller";

export const BG_COLOR_MAIN = "#FFFFFF";

export const BG_COLOR_ESTMATION_LEFT = "#27293d";
export const BG_COLOR_ESTMATION_CENTER = "#27293d";
export const BG_COLOR_ESTMATION_RIGHT = "#27293d";

export const BG_COLOR_ERROR_NO_REMAINING = "red";
export const BG_COLOR_ERROR_AI_FILE = "#1f1f2f";
export const BG_COLOR_ERROR_DAQ = "#1f1f2f";
export const BG_COLOR_ERROR_UNDER_SYRINGE = "#1f1f2f";
export const BG_COLOR_ERROR_ZERO_SYRINGE = "#1f1f2f";
export const BG_COLOR_ERROR_OVER_SHOT_COUNT = "#1f1f2f";


const bPrintLog = true;

export function faLog(type, log, json) {

    if (!bPrintLog) {
        return;
    }

    if (type == 0) {
        console.log(log);
    } else if (type == 1) {
        console.log(JSON.stringify(json, null, 2));
    } else if (type == 2) {
        if (json !== null) {
            console.log(log + " : " + JSON.stringify(json, null, 2));
        } else {
            console.log(log + " : null");
        }
    }
}

export function getTodayString() {
    const date = new Date();
    const today =
        date.getFullYear() + "-" +
        String(date.getMonth() + 1).padStart(2, "0") + "-" +
        String(date.getDate()).padStart(2, "0");
    // faLog(0, "[faUtils] [getTodayString] today : " + today);
    return today;
}

export function getNowDatetimeString() {
    const now = new Date();
    const strDatetime =
        now.getFullYear() + "-" +
        String(now.getMonth() + 1).padStart(2, "0") + "-" +
        String(now.getDate()).padStart(2, "0") + " " +
        String(now.getHours()).padStart(2, "0") + ":" +
        String(now.getMinutes()).padStart(2, "0") + ":" +
        String(now.getSeconds()).padStart(2, "0");
    return strDatetime;
};

export const FIRE_PORT_ROLE = {
    FA_PR_DISABLED: 0,             /* DISABLED */
    FA_PR_FIRE_DETECTION: 1,       /* 화재 (감지기) */
    FA_PR_FIRE_EQUIPMENT: 2,       /* 화재 (설비)  */
    FA_PR_EQUIPMENT_WORK: 3,       /* 설비작동 */
};

export const FIRE_PORT_DEFINITION = {
    /* FA_PRD_FIRE_DETECTION, 화재 (감지기) */
    FA_PRD_FD_SHORTAGE: 1,         /* 단락 */
    FA_PRD_FD_FIRE: 2,             /* 화재 */
    FA_PRD_FD_LOW_VOLTAGE: 3,      /* 저전압 */
    FA_PRD_FD_NORMAL: 4,           /* 정상 */
    FA_PRD_FD_BREAKING: 5,         /* 단선 */
    /* FA_PRD_FIRE_EQUIPMENT, 화재 (설비) */
    FA_PRD_FE_FIRE: 20,            /* 화재 */
    FA_PRD_FE_LOW_VOLTAGE: 21,     /* 저전압 */
    FA_PRD_FE_NORMAL: 22,          /* 정상 */
    FA_PRD_FE_BREAKING: 23,        /* 단선 */
    /* FA_PRD_EQUIPMENT_WORK, 설비작동 */
    FA_PRD_EW_WORK: 30,            /* 작동 */
    FA_PRD_EW_LOW_VOLTAGE: 31,     /* 저전압 */
    FA_PRD_EW_NORMAL: 32,          /* 정상 */
    FA_PRD_EW_BREAKING: 33,        /* 단선 */
    FA_PRD_DISABLED: 255,          /* DISABLED */
};

export const SEARCH_PERIOD = {
    FA_SEARCH_PERIOD_ONE_DAY: 0,
    FA_SEARCH_PERIOD_ONE_WEEK: 1,
    FA_SEARCH_PERIOD_ONE_MONTH: 2,
    FA_SEARCH_PERIOD_SIX_MONTH: 3,
    FA_SEARCH_PERIOD_ONE_YEAR: 4,
    FA_SEARCH_PERIOD_CUSTOM: 99,
};

export const getFirePortRole = (role) => {
    // faLog(0, "[getFirePortRole] role : " + role);
    switch (role) {
        case FIRE_PORT_ROLE.FA_PR_FIRE_DETECTION: return "감지기 화재";
        case FIRE_PORT_ROLE.FA_PR_FIRE_EQUIPMENT:  return "설비 화재 (압력 스위치 등)";
        case FIRE_PORT_ROLE.FA_PR_EQUIPMENT_WORK: return "설비 감시 (탬퍼 스위치 등)";
        case FIRE_PORT_ROLE.FA_PR_DISABLED:
        default: return "미사용 (Disabled)";
    }
};

export const getFirePortDefinition = (definition) => {
    switch (definition) {
        /* FA_PRD_FIRE_DETECTION, 화재 (감지기) */
        case FIRE_PORT_DEFINITION.FA_PRD_FD_SHORTAGE: return "단락";
        case FIRE_PORT_DEFINITION.FA_PRD_FD_FIRE: return "화재";
        case FIRE_PORT_DEFINITION.FA_PRD_FD_LOW_VOLTAGE: return "저전압";
        case FIRE_PORT_DEFINITION.FA_PRD_FD_NORMAL: return "정상";
        case FIRE_PORT_DEFINITION.FA_PRD_FD_BREAKING: return "단선";
        /* FA_PRD_FIRE_EQUIPMENT, 화재 (설비) */
        case FIRE_PORT_DEFINITION.FA_PRD_FE_FIRE: return "화재";
        case FIRE_PORT_DEFINITION.FA_PRD_FE_LOW_VOLTAGE: return "저전압";
        case FIRE_PORT_DEFINITION.FA_PRD_FE_NORMAL: return "정상";
        case FIRE_PORT_DEFINITION.FA_PRD_FE_BREAKING: return "단선";
        /* FA_PRD_EQUIPMENT_WORK, 설비작동 */
        case FIRE_PORT_DEFINITION.FA_PRD_EW_WORK: return "작동";
        case FIRE_PORT_DEFINITION.FA_PRD_EW_LOW_VOLTAGE: return "저전압";
        case FIRE_PORT_DEFINITION.FA_PRD_EW_NORMAL: return "정상";
        case FIRE_PORT_DEFINITION.FA_PRD_EW_BREAKING: return "단선";
        case FIRE_PORT_DEFINITION.FA_PRD_DISABLED:
        default: return "미사용 (Disabled)";
    }
};

export const getSearchPeriodType = (type) => {
    const prefix = "[검색기간] ";
    switch (type) {
        case SEARCH_PERIOD.FA_SEARCH_PERIOD_ONE_WEEK: return prefix + "1주";
        case SEARCH_PERIOD.FA_SEARCH_PERIOD_ONE_MONTH: return prefix + "1개월";
        case SEARCH_PERIOD.FA_SEARCH_PERIOD_SIX_MONTH: return prefix + "6개월";
        case SEARCH_PERIOD.FA_SEARCH_PERIOD_ONE_YEAR: return prefix + "1년";
        case SEARCH_PERIOD.FA_SEARCH_PERIOD_CUSTOM: return prefix + "사용자 입력";
        case SEARCH_PERIOD.FA_SEARCH_PERIOD_ONE_DAY:
        default: return prefix + "1일";
    }
};



export const classBindsServiceAgreement = [
    /** 00 */   "ma-2",
    /** 01 */   "mx-2 mt-6",
    /** 02 */   "mx-4 pa-2",
    /** 03 */   "mx-8 pa-2",
    /** 04 */   "mx-12 pa-2",
    /** 05 */   "mx-2 mt-12 pa-1",
    /** 06 */   "mx-4 pa-1",
];


export const styleBindsServiceAgreement = [
    /** 01 */ { overflow: "hidden",     textAlign: "center",    color: "black",             fontSize: "32px",       fontWeight: "bold",     },
    /** 02 */ { overflow: "hidden",     textAlign: "left",      color: "black",             fontSize: "24px",       fontWeight: "bold",     },
    /** 03 */ { overflow: "hidden",     textAlign: "left",      color: "black",             fontSize: "20px",       fontWeight: "normal",   },
    /** 04 */ { overflow: "hidden",     textAlign: "center",    color: "black",             fontSize: "14px",       fontWeight: "normal",   },
    /** 05 */ { overflow: "hidden",     textAlign: "center",    color: "black",             fontSize: "12px",       fontWeight: "normal",   },
];





